import React, { useEffect, useState } from "react";
import offerCover from "../../../assets/banner/offer.webp";
import Container from "../../../utils/Container";
import { OffersForAll } from "../../../api/website/home/homeApi";
import { useNavigate } from "react-router";
import useSEO from "../../../utils/seo";
import notAvailable from "../../../assets/icons/notAvailable.svg";
const OffersPage = () => {
  const navigate = useNavigate();
  const [IsLoading, setIsLoading] = useState(false);
  const [Offers, setOffers] = useState([]);
  useEffect(() => {
    OffersForAll(setOffers, setIsLoading);
  }, []);
  useSEO({
    title: "Offers - Dhoorbin.com",
    description: "Get all the offers on Dhoorbin.com",
    image: `${window.location.origin}/images/banner.png`,
    url: "https://dhoorbin.com/offers",
    canonical: "https://dhoorbin.com/offers",
    keywords: "travel, hotel, tour, booking",
    publisher: "Dhoorbin",
    robots: "index, follow",
    lang: "en",
  });
  return (
    <div>
      <div className="w-full h-auto lg:h-[400px]">
        <img
          src={offerCover}
          alt="Dhoorbin.com"
          className="w-full h-full object-contain lg:object-cover"
        />
      </div>
      <div className="py-10 lg:py-20">
        <Container>
          {IsLoading ? (
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-10">
              {Array.from({ length: 6 }).map((_, index) => {
                return (
                  <div
                    key={index}
                    className="w-full h-[180px] lg:h-[400px] animate-pulse bg-slate-200"
                  ></div>
                );
              })}
            </div>
          ) : (
            <>
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-10">
                {Offers.length > 0 ? (
                  <>
                    {Offers.map((item, index) => {
                      return (
                        <div
                          onClick={() =>
                            navigate(`/offer/${item.id}/${item.offerTitle}`)
                          }
                          key={index}
                          className="w-full h-[180px] lg:h-[400px]  rounded-lg overflow-hidden shadow-lg border border-[#cbddfd] cursor-pointer bg-white"
                        >
                          <img
                            className="w-full h-full object-cover"
                            src={item.featuredImage}
                            alt=""
                          />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className="col-span-2 lg:col-span-3 w-full h-[180px] lg:h-[600px] place-items-center">
                    <img
                      src={notAvailable}
                      alt=""
                      className="w-full h-full object-center object-contain"
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </Container>
      </div>
    </div>
  );
};

export default OffersPage;
